export default "__VITE_ASSET__DPIGH_4y__"